import { getTaskStatusColor } from './getTaskStatusColor';
import { hasCriticalError } from './hasCriticalError';
import { hasComment } from './hasComment';
import { getClients } from './getClients';
import { getSalesOrderIds } from './getSalesOrderIds';
import { useTaskStatusTranslation } from './useTaskStatusTranslation';
import { getGanttUnassigned } from './getGanttUnassigned';
import { hasOverdueError } from './hasOverdueError';
import { calculateRetooling } from './calculateRetooling';
export * from './isRangeEqual';
export * from './mapSSEDataToGanttQueues';
export * from './getTaskStatusColor';
export * from './getQueueStatusColor';
export * from './hasCriticalError';

export const GanttUtils = {
  getTaskStatusColor,
  hasCriticalError,
  hasComment,
  getClients,
  getSalesOrderIds,
  useTaskStatusTranslation,
  getGanttUnassigned,
  hasOverdueError,
  calculateRetooling,
};
